import axios from 'axios'

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
})

api.interceptors.request.use(config => {
  const token = localStorage.getItem('vf_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('vf_token')
      if (window.location.pathname !== '/auth') {
        window.location.href = '/auth'
      }
    }
    if (error.response?.status === 402) {
      const detail = error.response.data?.detail
      // Detect insufficient_credits (object with code field) vs plan gate (object with required_plan)
      const isCredits = typeof detail === 'object' && detail?.code === 'insufficient_credits'
      const event = new CustomEvent('billing:upgrade_required', {
        detail: {
          required_plan: isCredits ? 'pro' : (detail?.required_plan ?? 'pro'),
          feature: isCredits ? 'credits' : (detail?.feature ?? null),
          message: isCredits ? detail?.message : (detail?.message ?? null),
        },
      })
      window.dispatchEvent(event)
    }
    return Promise.reject(error)
  }
)

export default api
